var map = {
	"./aheadworks.webp": "4d06",
	"./buissonniere.webp": "f251",
	"./citrix_logo.webp": "d87e",
	"./citrixsynergy.webp": "d880",
	"./csc.webp": "52dc",
	"./csc_logo.webp": "922d",
	"./kukimi.webp": "1a81",
	"./kukimide.webp": "efd5",
	"./magento.webp": "15e9",
	"./magento_icons/adobe.webp": "3014",
	"./magento_icons/magento.webp": "689d",
	"./magento_icons/ms_azure.webp": "d54b",
	"./magento_icons/zabix.webp": "b54a",
	"./oscommers.webp": "7422",
	"./qg-main.webp": "3b8f",
	"./qg.webp": "987a",
	"./qg2.webp": "7ce2",
	"./transact.webp": "748d",
	"./york.webp": "bf8f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a4d9";